import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { CommonService } from 'app/reusable/common.service';
import { SetDossier } from 'app/_actions/intake.actions';
import { environment } from "environments/environment";
import { ROLES } from 'app/_constants/roles';
import { AuthenticationService } from 'app/_services';
import { CedNotificationService } from 'ced-ng-library';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-dossier-genesys-filtred',
  templateUrl: './dossier-genesys-filtred.component.html',
  styleUrls: ['./dossier-genesys-filtred.component.scss']
})
export class DossierGenesysFiltredComponent extends DialogContentBase  implements OnInit {

  @Input() dossierListFiltred : any;
  public serverUrlSlot2 : string = environment.Services.AlphaURLSlot2;
  selectedDossier : any;
  editMode: boolean = false;
  private _subject$: Subject<boolean> = new Subject();
  constructor(private commonService: CommonService,dialog: DialogRef,
    private store: Store,
    private authenticationService: AuthenticationService,
    private cedNotificationService: CedNotificationService) {super(dialog);}
    
  ngOnInit() {
    this.getRoles();
  }
  getRoles() {
    let roles = this.authenticationService.getLocalStorageRoles();
    if (roles != null) {
      this.editMode = roles.find(r => r.authorizationRoleId.trim() == ROLES.DOSSIER_MANAGEMENT && r.operationUpdate == true) != undefined;
    }
  }

  dblClickEvent() {
    if (this.selectedDossier != null)
      this.open(this.selectedDossier.dossierId, this.editMode);
    this.selectedDossier = null;
  }

  onCellClick($event) {
    this.selectedDossier = $event.dataItem
  }

  open(dossierId, editMode) {
    let GetDossierUrl: string = `Dossier/GetById/` + dossierId;
    this.commonService.getData(GetDossierUrl, this.serverUrlSlot2).pipe(takeUntil(this._subject$))
      .subscribe(
        (data: any) => {
          this.store.dispatch(new SetDossier(data, editMode));
          this.dialog.close();
        },
        (error) => {
            this.cedNotificationService.error("NOTIFICATIONS.GET_CASE");
        });
  }
  cancel()
  {
    this.dialog.close();
  }
}
